import * as React from "react";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import AppTheme from "../shared-theme/AppTheme";
import { CustomCard, CustomContainer } from "../shared-theme/BasicComponentTheme";
import { useNavigate } from "react-router-dom";

import McdcLogo from "../../assets/images/logo-mcdc.png";
import ClemsonLogo from "../../assets/images/logo-clemson.png";
import Stack from "@mui/material/Stack";
import { Alert, CircularProgress } from "@mui/material";
import { useEffect } from "react";
import { useAuthManager } from "../../hooks/useAuthHook";

export default function AuthCallbackWithGoogle(props: { disableCustomTheme?: boolean }) {

  const [unknownError, setUnknownError] = React.useState(false);
  const navigate = useNavigate();

  const { useSignInWithGoogleMutation } = useAuthManager();
  const { mutate: signInWithGoogle, isLoading: isSigning, error, data } = useSignInWithGoogleMutation();

  useEffect(() => {
    const handleAuthCallback = async () => {

      try {

        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get("code");

        //console.log("url paras, code", urlParams, code)

        if (!code) {
          navigate("/signin", { state: { message: "Authorization code is missing." } });
          return;
        }

        const onSuccess = (response: any) => {
          if (response.code === 200) {
            localStorage.setItem('id', response.data.id);
            localStorage.setItem('user', response.data.user);
            localStorage.setItem('email', response.data.email)
            localStorage.setItem('is_admin', response.data.is_admin)
            localStorage.setItem('access_token', response.data.access_token);
            localStorage.setItem('refresh_token', response.data.refresh_token);
            localStorage.setItem("is_user_logged_in", "true");
            localStorage.setItem('remember_me', "remember");

            navigate('/dashboard');
          }
        }

        const onError = (error: any) => {
          navigate("/signin", { state: { message: "Authorization code is invalid." } });
        }

        signInWithGoogle({ code: code, providerID: 1, redirectURI: process.env.REACT_APP_AUTH_REDIRECTION_URI || "" }, { onSuccess, onError });

      } catch (error) {
        navigate("/signin", { state: { message: "Authorization code is invalid." } });
      }
    }

    handleAuthCallback();
  }, [navigate]);

  return (
    <AppTheme {...props}>
      <CssBaseline enableColorScheme />
      <CustomContainer direction="column" justifyContent="space-between" >
        {/*<ColorModeSelect sx={{ position: 'fixed', top: '1rem', right: '1rem' }}/>*/}
        <CustomCard variant="outlined" className={"pt-3"}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              src={McdcLogo}
              alt="McdcLogo"
              style={{
                width: "auto",
                height: "auto",
                maxWidth: "120px",
                maxHeight: "120px",
                objectFit: "contain",
              }}
            />
            <img
              src={ClemsonLogo}
              alt="ClemsonLogo"
              style={{
                width: "auto",
                height: "auto",
                maxWidth: "50px",
                maxHeight: "50px",
                objectFit: "contain",
                // marginBottom: "16px"
              }}
            />
          </div>

          {/* unknown error. */}
          {unknownError && (
            <Stack sx={{ width: '100%' }} spacing={2}>
              <Alert severity="error">
                An unexpected error occurred. Please let us know at mcdcadmin@clemson.edu.
              </Alert>
            </Stack>
          )}

          <Box
            component="form"
            noValidate
            sx={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              gap: 2
            }}
          >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginTop: "2rem" }}>
              <CircularProgress />
              <Typography variant="h6" style={{ marginTop: "1rem" }}>
                Processing authentication...
              </Typography>
            </div>
          </Box>
        </CustomCard>
      </CustomContainer>
    </AppTheme>
  );
}
